module.exports = __webpack_public_path__ + "static/img/1.277e3ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/panorama/1.jpg
// module id = BBan
// module chunks = 1